(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elya-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.ecReady) return;
    root.dataset.ecReady = '1';
    var intro = root.querySelector('.ec-intro'), more = root.querySelector('.ec-more');
    if (intro && more && matchMedia('(max-width: 700px)').matches) {
      intro.classList.add('clamp');
      if (intro.scrollHeight > intro.clientHeight + 2) {
        more.hidden = false;
        more.addEventListener('click', function () { intro.classList.remove('clamp'); more.hidden = true; });
      } else intro.classList.remove('clamp');
    }
    var btns = root.querySelectorAll('[data-panel]');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var open = b.getAttribute('aria-expanded') !== 'true';
        btns.forEach(function (o) {
          o.setAttribute('aria-expanded', 'false');
          root.querySelector('#' + o.getAttribute('aria-controls')).hidden = true;
        });
        if (open) {
          b.setAttribute('aria-expanded', 'true');
          root.querySelector('#' + b.getAttribute('aria-controls')).hidden = false;
        }
      });
    });
    var form = root.querySelector('.ec-filters');
    if (form) form.addEventListener('submit', function () {
      form.querySelectorAll('input').forEach(function (i) { if (!i.value) i.disabled = true; });
    });
  }
  function initAll() { document.querySelectorAll('.ec').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
